/**
 * Generic function to sort an array of objects by a given property.
 * @param list The array to sort
 * @param key The property to sort by
 * @param direction 'asc' for ascending, 'desc' for descending
 */
export function sortList<T>(list: T[], key: keyof T, direction: 'asc' | 'desc' = 'asc'): T[] {
  return list.sort((a, b) => {
    const valueA = a[key];
    const valueB = b[key];

    // Handle numbers directly
    if (typeof valueA === 'number' && typeof valueB === 'number') {
      return direction === 'asc' ? valueA - valueB : valueB - valueA;
    }

     // Handle strings that are date representations
     if (typeof valueA === 'string' && !isNaN(Date.parse(valueA)) && typeof valueB === 'string' && !isNaN(Date.parse(valueB))) {
      const dateA = new Date(valueA);
      const dateB = new Date(valueB);
      return direction === 'asc' 
        ? dateA.getTime() - dateB.getTime() 
        : dateB.getTime() - dateA.getTime();
    }

    // Handle Date objects by comparing their timestamps
    if (valueA instanceof Date && valueB instanceof Date) {
      return direction === 'asc' 
        ? valueA.getTime() - valueB.getTime() 
        : valueB.getTime() - valueA.getTime();
    }

    // Handle strings (case-insensitive)
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return direction === 'asc'
        ? valueA.localeCompare(valueB, undefined, { sensitivity: 'base' })
        : valueB.localeCompare(valueA, undefined, { sensitivity: 'base' });
    }

    return 0; // Default case if types don't match
  });
}